export { default } from './ExpansionPanelSummary';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ExpansionPanelSummary/index.js
// module id = 327
// module chunks = 0